export default {
    availableCubes: (state, getters, rootState, rootGetters) => {
        if (state.pointEntries?.total) {
            return state.pointEntries.total - rootGetters['products/totalGoodies']
        } else {
            return 0
        }
    }
}